import { UnitDisplay, Units } from 'utils/constants';
import { formatNumber } from 'utils/numbers';

type IntegerProps = {
  className?: string;
  value: number;
  unit?: Units;
  unitDisplay?: UnitDisplay;
};

function Integer({ className, value, unit, unitDisplay = UnitDisplay.Short }: IntegerProps) {
  let val;
  if (unit) {
    val = formatNumber(value, {
      style: 'unit',
      unit,
      unitDisplay,
      maximumFractionDigits: 0,
    });
  } else {
    val = formatNumber(value, { maximumFractionDigits: 0 });
  }

  return (
    <span className={className} data-testid="integer">
      {val}
    </span>
  );
}

export default Integer;
